module.exports = __webpack_public_path__ + "img/Jump Casting80.bcf506ec.jpg";